import React from "react"
import { ListItemElement } from "./elements"

const ComposedListItem = props => {
  return <ListItemElement>{props.title}</ListItemElement>
}

export default ComposedListItem
